import type { PopupData } from 'webapp-types';

import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import ReportsArchiveResendFormComponent from 'webapp/components/reports/archive/resend-form';

export default class ReportsArchivePopupResendComponent extends PopupInnerModalComponent<PopupData.Report.ResendDelivery> {
	get model() {
		return this.popupData.model;
	}
	<template>
		<div class="title">
			<BoardImagePreviewComponent
				@image={{this.model.image}}
				@count={{this.model.slideCount}}
			/>
			<span>Resend '{{this.model.title}}'</span>
		</div>

		<div class="content">
			<ReportsArchiveResendFormComponent
				@model={{this.model}}
				@onContentChange={{this.scheduleReposition}}
				@onClose={{this.close}}
			/>
		</div>
	</template>
}
